module.exports = " ";


//////////////////
// WEBPACK FOOTER
// /app/suissealpine/static/app/poi/view/relations/partial.html
// module id = 458
// module chunks = 0